import $ from "jquery";
import _ from "lodash";
import Vue from "vue";
import { tippy } from "vue-tippy";

import * as clipboard from "@/utils/clipboard";

// Directive `v-blur` that prevents focus
// Source: https://github.com/vuetifyjs/vuetify/issues/8572
// ----
Vue.directive("blur", {
	inserted: function(el) {
		el.onfocus = ev => ev.target.blur();
	},
});

// Directive `v-clip` that adds 'click to copy text' behavior to any element. A
// tooltip will appear over the element, notifying the user that text was
// copied to the clipboard.
// ----

// v-clip click handler
const clipClick = (event, customClipTxt) => {
	const txt = _.trim(customClipTxt || $(event.currentTarget).text());
	console.debug("Copying text:", txt);
	try {
		clipboard.copy(txt);
	} catch (e) {
		console.error("Failed to copy to clipboard", e);

		// Notify bugsnag of error so we can figure out why clipboard isn't
		// working for a given brower/version.
		window.vm.$bugsnagClient.notify(e);
	}
};
// Add global tippy to page
const tippyOpts = {
	content: "Copied to clipboard",
	trigger: "click",
	sticky: false,
	zIndex: 9999,
	arrow: true,

	// Automatically hide tooltip
	onShow: ref => setTimeout(() => ref.hide(), 750),
};
// Directive definition
Vue.directive("clip", {
	bind: function(el, binding) {
		const $tippy = tippy(el, tippyOpts);

		let clipClickHandler = clipClick;
		if (binding.value)
			clipClickHandler = _.curryRight(clipClick)(binding.value);

		$(el).on("click", clipClickHandler);
		el.$destroy = () => {
			$(el).off("click", clipClickHandler);
			$tippy.destroy();
		};
	},

	update: function(el, binding) {
		let clipClickHandler = _.curryRight(clipClick);
		if (binding.value)
			clipClickHandler = _.curryRight(clipClick)(binding.value);

		$(el).off("click");
		$(el).on("click", clipClickHandler);
	},

	unbind: el => el.$destroy(),
});
